import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthApiService } from '../../_core/_services/auth-api.service';
import { NotificationService } from '../../_core/_services/notification.service';


type ResetPasswordForm = FormGroup<{
  newPassword: FormControl<string>;
  confirmPassword: FormControl<string>;
}>;

@Component({
  selector: 'app-reset-password',
  standalone: false,
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.css'
})
export class ResetPassword implements OnInit {
  token = '';
  validating = true;
  validToken = false;
  loading = false;
  submitted = false;
  completed = false;
  error = '';

  form!: ResetPasswordForm;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authApi: AuthApiService,
    private notify: NotificationService
  ) {
    this.form = this.fb.nonNullable.group({
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) {
      this.validating = false;
      this.error = 'The password reset link is missing its token.';
      return;
    }

    this.authApi.validatePasswordResetToken(this.token).subscribe({
      next: res => {
        this.validToken = !!res.data?.valid;
        if (!this.validToken) this.error = 'This password reset link is invalid or has expired.';
      },
      error: () => {
        this.error = 'This password reset link is invalid or has expired.';
        this.validating = false;
      },
      complete: () => this.validating = false
    });
  }

  submit(): void {
    this.submitted = true;
    this.error = '';
    if (this.form.invalid || !this.validToken || this.loading) return;

    const { newPassword, confirmPassword } = this.form.getRawValue();
    if (newPassword !== confirmPassword) {
      this.error = 'Password confirmation does not match.';
      return;
    }

    this.loading = true;
    this.authApi.resetPassword(this.token, newPassword, confirmPassword).subscribe({
      next: res => {
        this.completed = true;
        this.notify.showSuccess(res.message || 'Password reset successfully.', 'Password Recovery');
      },
      error: err => {
        this.error = err?.error?.message || err?.error?.Error?.Details || 'Password reset failed.';
        this.notify.showError(this.error, 'Password Recovery');
        this.loading = false;
      },
      complete: () => this.loading = false
    });
  }
}
